// extracted by mini-css-extract-plugin
module.exports = {"tabbedView":"TabbedView-module--tabbedView--nLRFa","tabContainer":"TabbedView-module--tabContainer---sQby","selectContainer":"TabbedView-module--selectContainer--3FoWh"};